import createVueComponent from '../createVueComponent';

const ListMinus = createVueComponent('ListMinusIcon', [
  ['path', { d: 'M11 12H3' }],
  ['path', { d: 'M16 6H3' }],
  ['path', { d: 'M16 18H3' }],
  ['path', { d: 'M21 12h-6' }],
]);

export default ListMinus;
